import React, { useEffect } from 'react';
import './prov_contra.css';

const Ligas = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container transparencia-container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h1 className='title'>Proveedores y Contratistas</h1>
          <hr className='hr-gob'/>
        </div>

        <div className='col-md-4 col-12 ofiprov-card'>
          <img src="/assets/imgs/oficina_virtual/1.-Padrón de Proveedores y Contratistas de la Administración Pública del Estado de Hidalgo.png" alt="Proveedores y Contratistas" className='ofiprov-img' />
          <h2 className='ofiprov-subtitle'>Padrón de Proveedores y Contratistas de la Administración Pública del Estado de Hidalgo</h2>
          <div className='ofiprov-links'>
            <a href="https://consultapadroncontraloria.hidalgo.gob.mx/" target="_blank" rel="noopener noreferrer" 
            className='btn-oficina'>Ir al Servicio</a>
            {/* <a href="https://ruts.hidalgo.gob.mx/ver/392" target="_blank" rel="noopener noreferrer" className='btn-oficina'>Requisitos</a> */}
            {/* <span className='btn-oficina btn-oficina--red'>Video Tutorial</span> */}
          </div>
        </div>


          <div className='col-md-4 col-12 ofiprov-card'>
          <img src="/assets/imgs/oficina_virtual/2.-Sancionados.png" alt="Sancionados" className='ofiprov-img' />
          <h2 className='ofiprov-subtitle'>Registro de Proveedores y Contratistas Sancionados del Gobierno del Estado de Hidalgo</h2>
          <div className='ofiprov-links'>
            <a href="https://s-contraloria.hidalgo.gob.mx/interes/Sancionados.htm" target="_blank" rel="noopener noreferrer" 
            className='btn-oficina'>Ir al Servicio</a>
            {/* <a href="https://ruts.hidalgo.gob.mx/ver/1602" target="_blank" rel="noopener noreferrer" className='btn-oficina'>Requisitos</a>
            <span className='btn-oficina btn-oficina--red'>Video Tutorial</span> */}
          </div>
        </div>


        <div className='col-md-4 col-12 ofiprov-card'>
          <img src="/assets/imgs/oficina_virtual/3.-Sin efectos fiscales.png" alt="Proveedores" className='ofiprov-img' />
          <h2 className='ofiprov-subtitle'>Proveedores que quedan sin efectos en el Padrón de Proveedores </h2>
          <div className='ofiprov-links'>
            
             {/* <a href="https://esit.hidalgo.gob.mx/eSIT/oficinaVirtual/P1_mov_padron/oficina_virtual/c_oficina_virtual_ss.jsp?cve_ruts=SC/SC/412" target="_blank" rel="noopener noreferrer" 
           
           className='btn-oficina'>Ir al Servicio</a> */}
            {/* <a href="https://ruts.hidalgo.gob.mx/ver/409" target="_blank" rel="noopener noreferrer" className='btn-oficina'>Requisitos</a>
            <span className='btn-oficina btn-oficina--red'>Video Tutorial</span> Proveedores que quedan sin efectos en el Padrón de Proveedores Circular  publicada el 00/00/2026 */}
          </div>
        </div>

       

        <div className='col-12 ofiprov-contact'>
          <div className='ofiprov-contact-box'>
            <p>Para cualquier consulta, ponemos a su disposición los siguientes medios de contacto en horario laboral, de 9:00 a.m. a 5:00 p.m.:</p>
            <p><strong>Correo electrónico:</strong> <a href="mailto:agenda.padron@hidalgo.gob.mx">agenda.padron@hidalgo.gob.mx</a></p>
        
          </div>
        </div>
      </div>
    </div>
  )
}

export default Ligas;
